import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export interface ICardBrandResponseParameter {
  id: number;
  brandName: string;
  brandCode: string;
}

export type GetCardBrandListResponse = BaseResponse<Array<ICardBrandResponseParameter>>;

async function getCardBrandList(): Promise<GetCardBrandListResponse> {
  try {
    return (await axiosInstance.get("/Merchant/ListCardBrands")).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetCardBrandsList() {
  return useMutation<
    GetCardBrandListResponse,
    Error,
    null
  >(() => getCardBrandList());
}
